module.exports = __webpack_public_path__ + "static/media/fly0226.3aa3d1e2.webp";